import React from 'react';
import Card from '../../../shared/components/Card';
import CardBody from '../../../shared/components/CardBody';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import Paginator from '../../../shared/components/Paginator';
import Row from '../../../shared/components/Row';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import { PsNotificationStates } from '../PsNotificationStates';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { NotificationSearchTask } from '../shared/notification-search/NotificationSearchTask';
import { NotificationSearchRequest } from '../shared/notification-search/NotificationSearchRequest';
import { PsNotification } from '../PsNotification';
import { NotificationListTable } from './NotificationListTable';
import { NotificationResolveRequest } from './notification-resolve/NotificationResolveRequest';
import { NotificationResolveTask } from './notification-resolve/NotificationResolveTask';
import Alert from 'react-s-alert';
import { CurrentUser } from '../../../shared/model/CurrentUser';
import UserRole from '../../../shared/model/UserRole';
import { connect } from 'react-redux';
import HeaderFilterNotificationOptions from '../list/component/HeaderFilterNotificationOptions';

class NotificationListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            error: '',
            search: '',
            loading: false,
            page: 1,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
            filter: PsNotificationStates.ALL,
            filters: [
                {
                    id: PsNotificationStates.ALL,
                    title: I18nUtils.tr('TR_TODAS'),
                    active: true,
                    onClick: this.selectFilter(PsNotificationStates.ALL),
                },
                {
                    id: PsNotificationStates.NO_SOLVED,
                    title: I18nUtils.tr('TR_NO_RESUELTAS'),
                    active: false,
                    onClick: this.selectFilter(PsNotificationStates.NO_SOLVED),
                },
                {
                    id: PsNotificationStates.SOLVED,
                    title: I18nUtils.tr('TR_RESUELTAS'),
                    active: false,
                    onClick: this.selectFilter(PsNotificationStates.SOLVED),
                },
            ],
        };
    }

    componentDidMount() {
        this.listNotifications();
    }

    render() {
        const { hasPermissionToResolve } = this.props;
        const {
            data,
            error,
            search,
            filters,
            loading,
            pagination,
            page,
            filter,
        } = this.state;

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODAS_LAS_NOTIFICACIONES')}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                onSearch={this.searchTerm}
                                onRefresh={this.listNotifications}
                                searchText={search}
                                enableFilter={true}
                                filterOptions={filters}
                            />
                        )}
                    />
                    <CardBody>
                        <HeaderFilterNotificationOptions
                            page={page}
                            search={search}
                            filter={filter}
                        />
                        <hr/>
                        <NotificationListTable
                            data={data}
                            error={error}
                            loading={loading}
                            resolveNotification={this.resolveNotification}
                            hasPermissionToResolve={hasPermissionToResolve}
                        />
                        <Paginator
                            data={pagination}
                            onPage={this.selectPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    subtitle = () => {
        switch ( this.state.filter ) {
            case PsNotificationStates.ALL:
                return I18nUtils.tr('TR_TODAS');
            case PsNotificationStates.SOLVED:
                return I18nUtils.tr('TR_RESUELTAS');
            case PsNotificationStates.NO_SOLVED:
                return I18nUtils.tr('TR_NO_RESUELTAS');
            default:
                return '';
        }
    };

    selectPage = (page) => {
        this.setState({ page }, this.listNotifications);
    };

    searchTerm = (search) => {
        this.setState({ search, page: 1 }, this.listNotifications);
    };

    selectFilter = (filter) => () => {
        this.setState(
            (prevState) => ( {
                page: 1,
                filter,
                filters: prevState.filters.map((f) => ( {
                    ...f,
                    active: f.id === filter,
                } )),
            } ),
            this.listNotifications,
        );
    };

    listNotifications = () => {
        const { page, search, filter } = this.state;
        const request = new NotificationSearchRequest();

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);

        new NotificationSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsNotification.fromAPINotifications(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail((error) => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    resolveNotification = (notification, solved) => {
        const request = new NotificationResolveRequest();

        request.setNotification(notification);
        request.setResolution(solved);

        new NotificationResolveTask(request)
            .onSuccess(() => this.notificationResolved(notification, solved))
            .onFail((error) => Alert.error(error))
            .execute();
    };

    notificationResolved = (notification, solved) => {
        notification.setSolved(solved);

        this.setState((prevState) => ( {
            data: prevState.filter === PsNotificationStates.ALL
                ? [...prevState.data]
                : prevState.data.filter((n) => n.id() !== notification.id()),
        } ));
    };
}

const mapStateToProps = state => {
    var currentUser = CurrentUser.fromReduxState(state);

    return {
        hasPermissionToResolve: currentUser.role() !== UserRole.OUTSOURCES_VIEWER,
    };
};

export default connect(mapStateToProps)(NotificationListCard);

NotificationListCard.propTypes = {};

NotificationListCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/NotificationListCard.jsx